import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthCard } from "~/components/auth/auth-card";
import { AuthShell } from "~/components/auth/auth-shell";
import { createNoIndexMeta } from "~/lib/shared/meta";

import { TrialStarted } from "./-components/trial-started";

export const Route = createFileRoute("/trial-started/")({
  staticData: { title: "Starting your trial" },
  validateSearch: z.object({
    checkout_session_id: z.string().max(255).optional().catch(undefined),
  }),
  head: () =>
    createNoIndexMeta(
      "Starting your trial – Dream Coach Match",
      "Starting your NOVA trial.",
    ),
  component: TrialStartedPage,
});

/**
 * Where Stripe Checkout returns a trial started signed out. This browser goes on
 * to the finish page only if its handoff cookie matches the paid session.
 */
function TrialStartedPage(): React.JSX.Element {
  const { checkout_session_id } = Route.useSearch();
  return (
    <AuthShell>
      <AuthCard>
        <TrialStarted checkoutSessionId={checkout_session_id ?? null} />
      </AuthCard>
    </AuthShell>
  );
}
